import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const handleImageUpload = createAsyncThunk(
  "imageUploadApi",
  async (payload) => {
    let formData = new FormData();
    formData.append("Guid", payload?.Guid);
    formData.append("Page", "PhelboDailyUpload");
    formData.append("Selfie", payload?.Selfie);
    formData.append("Bike", payload?.Bike);
    formData.append("Bag", payload.Bag);
    formData.append("userId", window?.localStorage?.getItem("user-Id"));
    formData.append("CompanyID", window?.localStorage?.getItem("CompanyID"));

    const response = await axios.post(
      "api/v1/HomeCollectionMobileApp/DefaultLoginData",
      formData
    );
    return response.data;
  }
);

const initialState = {
  error: false,
  loading: false,
  success: false,
  data: [],
};

export const postImageData = createSlice({
  name: "postImageUpload",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(handleImageUpload.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(handleImageUpload.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(handleImageUpload.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { postImageUpload } = postImageData.actions;

export default postImageData.reducer;
